module.exports = __webpack_public_path__ + "static/media/shareLinkIcon.0245631e.svg";